module.exports = __webpack_public_path__ + "img/giphy.340feb50.gif";